/* eslint-disable react/require-default-props */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Link } from '@fieldnation/platform-components';
import { useRecoilValue } from 'recoil';
import { IDisabledContent } from './types.d';

import css from './styles.scss';
import SUPPORT_CASE_URL from '../../../SectionCard/Components/SupportText/Constants';
import userPermissionState from '../../../SectionCard/States/Selectors';

const HIDE_SUPPORT_TEXT_ITEMS = ['username', 'legal name'];

export const DisabledContent = ({
  itemName = 'this section',
  disabled = true,
}: IDisabledContent): JSX.Element => {
  const { hasSupportBotAction } = useRecoilValue(userPermissionState);

  if (disabled) {
    // Show plain text (no link) for specific items when support bot action is enabled
    if (hasSupportBotAction && HIDE_SUPPORT_TEXT_ITEMS.includes(itemName.toLowerCase())) {
      return (
        <span className={css['disabled-text']}>
          {`Contact support to change ${itemName}.`}
        </span>
      );
    }

    return (
      <span className={css['disabled-text']}>
        <Link
          href={SUPPORT_CASE_URL}
          target="_blank"
        >
          Contact support
        </Link>
        {` to change ${itemName}.`}
      </span>
    );
  }
  return <></>;
};
